import { Link } from 'react-router-dom'
import { MenuDelDia } from './Carta'
import { useContacto, telefonoEnlace, lineas, urlComoLlegar, urlMapaEmbed } from '../data/contacto'
import './Inicio.css'

const FOTOS = [
  { src: '/galeria/foto-entrada.jpeg', alt: 'Entrada del restaurante' },
  { src: '/galeria/salon-completo.jpeg', alt: 'Salón completo' },
  { src: '/galeria/terraza.jpeg', alt: 'Terraza exterior' },
  { src: '/galeria/bar.jpeg', alt: 'Interior del bar' },
  { src: '/galeria/salon-vip.jpeg', alt: 'Salón VIP privado' },
  { src: '/galeria/entrada.jpeg', alt: 'Fachada exterior' },
]

function Carrusel() {
  const tira = [...FOTOS, ...FOTOS]
  return (
    <div className="carrusel-wrap">
      <div className="carrusel-tira">
        {tira.map((f, i) => (
          <div key={i} className="carrusel-slide">
            <img src={f.src} alt={f.alt} className="carrusel-img" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Inicio() {
  const c = useContacto()
  const tel = telefonoEnlace(c.telefono)
  return (
    <main>
      {/* HERO */}
      <section className="hero">
        <video className="hero-video" src="/video-entrada.mp4" autoPlay muted loop playsInline />
        <div className="hero-overlay"></div>
        <div className="hero-lines"></div>
        <div className="hero-content">
          <p className="hero-label">Agost · Alicante · Bar & Restaurante</p>
          <h1 className="hero-title">El Rincón de la <em>Escandella</em></h1>
          <p className="hero-subtitle">Dentro de Cerámica La Escandella · Agost</p>
          <div className="hero-divider"></div>
          <div className="hero-btns">
            <Link to="/reservas" className="btn-gold">Reservar Mesa</Link>
            <a href="#carta" className="btn-outline">Menú del día</a>
          </div>
        </div>
        <div className="scroll-indicator">
          <span>Descubrir</span>
          <div className="scroll-line"></div>
        </div>
      </section>

      {/* NOSOTROS */}
      <section className="nosotros" id="nosotros">
        <div className="nosotros-img">
          <img src="/galeria/salon-completo.jpeg" alt="Interior del Rincón de la Escandella" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        </div>
        <div className="nosotros-text">
          <p className="section-label">Nuestra historia</p>
          <h2 className="section-title">Un rincón con alma en el corazón de Alicante</h2>
          <div className="section-divider"></div>
          <p className="section-text">Bar El Rincón de la Escandella es un espacio donde la tradición y la modernidad se encuentran. Ubicados en Alicante, ofrecemos una experiencia gastronómica cuidada, con productos frescos de temporada y una carta de bebidas seleccionada con esmero.</p>
          <p className="section-text">Nuestro equipo trabaja cada día para que cada visita sea memorable. Desde el desayuno hasta el cóctel de la noche, siempre encontrarás el ambiente perfecto.</p>
          <div className="nosotros-stats">
            <div className="stat">
              <span className="stat-num">100%</span>
              <span className="stat-label">Producto fresco</span>
            </div>
            <div className="stat">
              <span className="stat-num">6</span>
              <span className="stat-label">Días abierto</span>
            </div>
            <div className="stat">
              <span className="stat-num">07:30</span>
              <span className="stat-label">Abrimos</span>
            </div>
          </div>
        </div>
      </section>

      {/* CARTA */}
      <section className="carta-section" id="carta">
        <div className="section-center">
          <p className="section-label">Gastronomía</p>
          <h2 className="section-title">Menú del día</h2>
          <div className="section-divider" style={{ margin: '1rem auto 2rem' }}></div>
          <MenuDelDia precio={c.menu_dia_precio} />
        </div>
      </section>

      {/* GALERIA */}
      <section className="galeria-section" id="galeria">
        <p className="section-label">Ambiente</p>
        <h2 className="section-title">Galería</h2>
        <div className="section-divider"></div>
        <Carrusel />
      </section>

      {/* RESERVAS CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <p className="section-label">¿Tienes planes?</p>
          <h2 className="section-title">Reserva tu mesa</h2>
          <div className="section-divider" style={{ margin: '1rem auto 2rem' }}></div>
          <p className="section-text" style={{ margin: '0 auto 2rem' }}>Asegura tu lugar en El Rincón de la Escandella. Fácil y rápido.</p>
          <Link to="/reservas" className="btn-gold">Hacer una Reserva</Link>
        </div>
      </section>

      {/* CONTACTO */}
      <section className="contacto-section" id="contacto">
        <p className="section-label">Encuéntranos</p>
        <h2 className="section-title">Contacto</h2>
        <div className="section-divider"></div>
        <div className="contacto-grid">
          <div className="contacto-item">
            <p className="contacto-label">Dirección</p>
            <p className="contacto-value">{lineas(c.direccion).map((l, i) => <span key={i}>{l}<br/></span>)}</p>
          </div>
          {c.telefono && (
            <div className="contacto-item">
              <p className="contacto-label">Teléfono</p>
              <p className="contacto-value"><a href={`tel:${tel}`} className="contacto-link">{c.telefono}</a></p>
            </div>
          )}
          <div className="contacto-item">
            <p className="contacto-label">Horario</p>
            <p className="contacto-value">{lineas(c.horario).map((l, i) => <span key={i}>{l}<br/></span>)}</p>
          </div>
          <div className="contacto-item">
            <p className="contacto-label">Email</p>
            <p className="contacto-value"><a href={`mailto:${c.email}`} className="contacto-link" style={{ wordBreak: 'break-all' }}>{c.email}</a></p>
          </div>
        </div>
        <div className="mapa">
          <iframe
            src={urlMapaEmbed(c.busqueda_maps)}
            title="Mapa Bar El Rincón de la Escandella"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="mapa-acciones">
          <a href={urlComoLlegar(c.busqueda_maps)} target="_blank" rel="noopener noreferrer" className="btn-outline">Cómo llegar</a>
          {c.telefono && <a href={`tel:${tel}`} className="btn-gold">Llamar al bar</a>}
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="footer-logo">El Rincón de la Escandella</div>
        <p className="footer-copy">
          &copy; {new Date().getFullYear()} Bar El Rincón de la Escandella · Agost (Alicante)
          {c.telefono && <> · <a href={`tel:${tel}`} className="contacto-link">{c.telefono}</a></>}
        </p>
        <div className="footer-links">
          <Link to="/">Inicio</Link>
          <Link to="/carta">Menú del día</Link>
          <Link to="/reservas">Reservas</Link>
          <a href="#contacto">Contacto</a>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/login" style={{ opacity: 0.3, fontSize: '0.6rem' }}>·</Link>
        </div>
      </footer>
    </main>
  )
}
